export const HISTORY_DEPTH = 21
export const PERBILL = 1_000_000_000
export const PERQUINT = 1_000_000_000_000_000_000
